import Grid from "@mui/material/Grid/Grid";
import InputForm from "./InputForm";
import logo from "../../../assets/cosmo-logo-gray.svg";
import styles from "./DesktopView.module.css";
import CustomStepper from "../../../components/CustomStepper";

const DesktopView = () => (
  <Grid container direction="column" style={{ minWidth: "100%", minHeight: "100vh" }}>
    <Grid
      item
      sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", borderRadius: "16px", background: "#FFFEFA", border: "0", padding: "28px 0", margin: "20px 20px 0 20px", boxShadow: "0px 0px 20px 0px #655B501A" }}
    >
      <img src={logo} className={styles.logo} alt="cosmo logo" />
      <CustomStepper activeStep={0} />
      <img src={logo} className={`${styles.logo} ${styles.hidden_logo}`} alt="hidden cosmo logo" />
    </Grid>
    <Grid container item xs={11} direction="row" sx={{ py: "40px" }}>
      <Grid item xs={6} container style={{ justifyContent: "center" }}>
        <img src="/activationbg-desktop.webp" fetchPriority="high" className={styles.watch_img} alt="cosmo watch with QR code" />
      </Grid>
      <Grid item xs={6}>
        <InputForm />
      </Grid>
    </Grid>
  </Grid>
);
export default DesktopView;
